<template>
    <div>
        <v-data-table :headers="headers" :items="list" :items-per-page="5" :sort-desc="[false, true]" hide-default-footer class="paginated-table table-striped table-hover">
            <template v-slot:top>
                <v-row justify="space-between">
                    <v-col class="d-flex" cols="6" sm="2">
                        <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
                    </v-col>
                    <v-col class="d-flex" cols="6" sm="2">
                        <v-text-field v-model="searchQuery" label="查找" type="search" class="mb-3" clearable style="width: 200px"></v-text-field>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.template="{ item }">{{ tempMap[item.template] }}</template>
            <template v-slot:item.option="{ item }">
                <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleEdit(item)" style="padding-right: 30px;">
                    <md-icon>edit</md-icon>
                </md-button>
                <md-button class="md-just-icon md-danger md-round md-simple" @click.native="handleDelete(item)">
                    <md-icon>close</md-icon>
                </md-button>
            </template>
        </v-data-table>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
            </div>
            <div class="md-layout-item md-size-50">
                <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total"> </pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { Pagination } from '@/components'
export default {
    components: {
        Pagination
    },
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            headers: [
                { text: '动作名称', align: 'center', value: 'name' },
                { text: '动作模板', align: 'center', value: 'template' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            tempMap: {
                move: '移动',
                view: '切换视角',
                talk: '说话',
                bfdh: '播放动画'
            }
        }
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            return this.list.length
        }
    },
    methods: {
        handleEdit(index) {
            this.$emit('handleEdit', index)
        },
        handleDelete(index) {
            this.$emit('handleDelete', index)
        }
    }
}
</script>
<style></style>